import { Link, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import charly from "../assets/images/charly.svg";
import charly2 from "../assets/images/charly2.svg";
import wave from "../assets/images/wave.svg";

const Body = ({ children }) => {
  const { pathname } = useLocation();
  const img = pathname === "/" ? charly2 : charly;

  return (
    <main className="auth-body-container">
      <Container>
        <div className="auth-grid-split">
          <div className="mascot-section d-none d-lg-flex">
            <img src={img} alt="Charly Mascot" className="charly-float" />
          </div>
          <div className="form-section">
            {children}
          </div>
        </div>
      </Container>
      <style>{`
        .auth-body-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          padding: 80px 0;
          background-color: var(--pastel-blue); /* Playful background color */
          background-image: radial-gradient(circle at 20% 30%, var(--pastel-pink) 0%, transparent 40%),
                            radial-gradient(circle at 80% 70%, var(--pastel-green) 0%, transparent 40%);
        }
        .auth-grid-split {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          align-items: center;
        }
        @media (max-width: 991px) {
          .auth-grid-split {
            grid-template-columns: 1fr;
          }
        }
        .charly-float {
          width: 100%;
          max-width: 500px;
          filter: drop-shadow(0 20px 30px rgba(0,0,0,0.1));
          animation: float 5s ease-in-out infinite;
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-25px) rotate(2deg); }
        }
        .form-section {
          display: flex;
          justify-content: center;
          width: 100%;
        }
      `}</style>
    </main>
  );
};

export default Body;
